// extracted by mini-css-extract-plugin
export default {"customContainer":"styles_customContainer__KxyKp","customContainerSmall":"styles_customContainerSmall__wyrKn","customContainerMedium":"styles_customContainerMedium__asQIG"};